import React from 'react';

const Pulse = () => {
  return (
    <div className="section" id="latest">
      <h2>Pulse Check</h2>
      <p>
        A snapshot of the current signals, active flags, and what I am monitoring right now.
      </p>
      <div className="card-container">
        <div className="latest-updates">
          <p><strong>Basic State</strong></p>
          <ul>
            <li>Running several Red Flags on blood biomarkers that I'm addressing</li>
            <li>Testing and research showing I'm over-compensating on garlic, turmeric, and omega-6 (from walnuts) and need to back off</li>
          </ul>
        </div>

        <div className="latest-updates">
          <p><strong>Sleep and Recovery</strong></p>
          <ul>
            <li>Sleep performance at 82% average</li>
            <li>Recovery is at 67% on the 30 day average</li>
            <li>Average strain of 12 for the past month</li>
            <li>HRV monthly average at 30</li>
          </ul>
        </div>

        <div className="latest-updates">
          <p><strong>Project Updates</strong></p>
          <ul>
            <li>Rhodium Life iPhone app to track health for longevity</li>
            <li>Updates to nutrition, supplements, and food</li>
            <li>Updated terms and privacy information</li>
          </ul>
        </div>
      </div>

      <h4>Red Flags</h4>
      <div className="card-container">
        <div className="latest-updates-flags">
          <p><strong>Afib(8x) Last Dec 2024</strong></p>
        </div>
        <div className="latest-updates-flags">
          <p><strong>Torn L Meniscus 2019</strong></p>
        </div>
        <div className="latest-updates-flags">
          <p><strong>Low HRV Oct 2024</strong></p>
        </div>
        <div className="latest-updates-flags">
          <p><strong>Low DHEA Jan 2025</strong></p>
        </div>
        <div className="latest-updates-flags">
          <p><strong>High MPO March 2025</strong></p>
        </div>
      </div>
<h4>Interventions (Fixes)</h4>
      <div className="card-container">
        <div className="latest-updates-fixes">
          <p><strong>Kidney Stone Sep 2022</strong></p>
          <span className="info-icon">i
            <span className="tooltip">Passed naturally, removed protein bars, sausage meat, no recurrence.</span>
          </span>
        </div>
        <div className="latest-updates-fixes">
          <p><strong>High LDL Chol - Fixed May 2025</strong></p>
          <span className="info-icon">i
            <span className="tooltip">Significant points dropped via fitness, cutting animal proteins (Meat & Chicken), and adding cinnamon, ginger power, garlic pills to my daily routine for inflammation.</span>
          </span>
        </div> 
        <div className="latest-updates-fixes">
          <p><strong>High ApoB - Fixed May 2025</strong></p>
                    <span className="info-icon">i
            <span className="tooltip">Significant points dropped from cutting animal proteins (Meat & Chicken) and adding cinnamon, ginger power, garlic pills to my daily routine for inflammation.</span>
          </span>
        </div>
      </div>
      <p>Note: To learn more about my history and fixes check out the Rhodium Papers link.</p>
      <br />
            <h3>Rhodium Life (iPhone App)</h3>
      <div className="text-image-wrapper">
        <img
          src="/images/RhodiumLifeHome.png"
          alt="Rhodium Life iPhone app preview"
          className="journey-image"
          style={{ height: 'auto', maxHeight: '520px', objectFit: 'contain' }}
        />
        <p>
          I built Rhodium Life as a simple way to bring the journey into your day-to-day.
          <br />
          <br />
          Your data stays on your device and your AI key stays yours. No data is sent to servers or third parties except for the AI key you provide to access AI features.
          <br />
          <br />
          Rhodium Life is your personal health operating system, designed to aggregate, analyze, and visualize your biomarker, fitness, and nutrition data from various sources.
          <br />
          <br />
          If you want to follow along and support the project, you can download it on the App Store.
          <br />
          <br />
          <a
            className="card-container-button"
            href="https://apps.apple.com/app/id6756220909"
            target="_blank"
            rel="noreferrer"
            style={{ display: 'inline-block', textDecoration: 'none' }}
          >
            View Rhodium Life on the App Store
          </a>
        </p>
      </div>
    </div>
  );
};

export default Pulse;
